export interface PmsCapability {
  practiceManagementSystem: string;
  automaticVerification: boolean;
  manualVerification: boolean;
  realTimeEligibilityReport: boolean;
  insuranceInfoWritebacks: boolean;
  eligibilityPdfUploads: boolean;
  notes: string | null;
}

export const PMS_CAPABILITIES: PmsCapability[] = [
  {
    practiceManagementSystem: 'Carestream Sensei',
    automaticVerification: false,
    manualVerification: true,
    realTimeEligibilityReport: true,
    insuranceInfoWritebacks: false,
    eligibilityPdfUploads: false,
    notes: null,
  },
  {
    practiceManagementSystem: 'Curve (Not supported)',
    automaticVerification: false,
    manualVerification: false,
    realTimeEligibilityReport: false,
    insuranceInfoWritebacks: false,
    eligibilityPdfUploads: false,
    notes: null,
  },
  {
    practiceManagementSystem: 'Denticon',
    automaticVerification: true,
    manualVerification: true,
    realTimeEligibilityReport: true,
    insuranceInfoWritebacks: false,
    eligibilityPdfUploads: true,
    notes: null,
  },
  {
    practiceManagementSystem: 'Dentimax V. 18+',
    automaticVerification: false,
    manualVerification: true,
    realTimeEligibilityReport: true,
    insuranceInfoWritebacks: false,
    eligibilityPdfUploads: false,
    notes: null,
  },
  {
    practiceManagementSystem: 'Dentrix Ascend',
    automaticVerification: false,
    manualVerification: true,
    realTimeEligibilityReport: true,
    insuranceInfoWritebacks: false,
    eligibilityPdfUploads: false,
    notes: null,
  },
  {
    practiceManagementSystem: 'Dentrix Enterprise',
    automaticVerification: false,
    manualVerification: true,
    realTimeEligibilityReport: true,
    insuranceInfoWritebacks: false,
    eligibilityPdfUploads: false,
    notes: null,
  },
  {
    practiceManagementSystem: 'Dentrix G3',
    automaticVerification: true,
    manualVerification: true,
    realTimeEligibilityReport: true,
    insuranceInfoWritebacks: false,
    eligibilityPdfUploads: false,
    notes: null,
  },
  {
    practiceManagementSystem: 'Dentrix G4',
    automaticVerification: true,
    manualVerification: true,
    realTimeEligibilityReport: true,
    insuranceInfoWritebacks: false,
    eligibilityPdfUploads: false,
    notes: null,
  },
  {
    practiceManagementSystem: 'Dentrix G5',
    automaticVerification: true,
    manualVerification: true,
    realTimeEligibilityReport: true,
    insuranceInfoWritebacks: false,
    eligibilityPdfUploads: true,
    notes: null,
  },
  {
    practiceManagementSystem: 'Dentrix G6.2-7',
    automaticVerification: true,
    manualVerification: true,
    realTimeEligibilityReport: true,
    insuranceInfoWritebacks: false,
    eligibilityPdfUploads: true,
    notes: null,
  },
  {
    practiceManagementSystem: 'Dentrix G6 / Canada',
    automaticVerification: false,
    manualVerification: true,
    realTimeEligibilityReport: true,
    insuranceInfoWritebacks: false,
    eligibilityPdfUploads: false,
    notes: null,
  },
  {
    practiceManagementSystem: 'Dolphin',
    automaticVerification: true,
    manualVerification: true,
    realTimeEligibilityReport: true,
    insuranceInfoWritebacks: false,
    eligibilityPdfUploads: false,
    notes: null,
  },
  {
    practiceManagementSystem: 'Dolphin Blue',
    automaticVerification: false,
    manualVerification: true,
    realTimeEligibilityReport: true,
    insuranceInfoWritebacks: false,
    eligibilityPdfUploads: false,
    notes: null,
  },
  {
    practiceManagementSystem: 'Dolphin Cloud',
    automaticVerification: false,
    manualVerification: true,
    realTimeEligibilityReport: true,
    insuranceInfoWritebacks: false,
    eligibilityPdfUploads: false,
    notes: null,
  },
  {
    practiceManagementSystem: 'DSN Dental Exec',
    automaticVerification: false,
    manualVerification: true,
    realTimeEligibilityReport: true,
    insuranceInfoWritebacks: false,
    eligibilityPdfUploads: false,
    notes: null,
  },
  {
    practiceManagementSystem: 'Eaglesoft 16',
    automaticVerification: true,
    manualVerification: true,
    realTimeEligibilityReport: true,
    insuranceInfoWritebacks: false,
    eligibilityPdfUploads: false,
    notes: null,
  },
  {
    practiceManagementSystem: 'Eaglesoft 17',
    automaticVerification: true,
    manualVerification: true,
    realTimeEligibilityReport: true,
    insuranceInfoWritebacks: false,
    eligibilityPdfUploads: false,
    notes: null,
  },
  {
    practiceManagementSystem: 'Eaglesoft 18/19/20/21',
    automaticVerification: true,
    manualVerification: true,
    realTimeEligibilityReport: true,
    insuranceInfoWritebacks: false,
    eligibilityPdfUploads: false,
    notes: null,
  },
  {
    practiceManagementSystem: 'Eaglesoft Insight',
    automaticVerification: false,
    manualVerification: true,
    realTimeEligibilityReport: true,
    insuranceInfoWritebacks: false,
    eligibilityPdfUploads: false,
    notes: null,
  },
  {
    practiceManagementSystem: 'Easy Dental - Dentrix',
    automaticVerification: false,
    manualVerification: true,
    realTimeEligibilityReport: true,
    insuranceInfoWritebacks: false,
    eligibilityPdfUploads: false,
    notes: null,
  },
  {
    practiceManagementSystem: 'Eddson',
    automaticVerification: false,
    manualVerification: true,
    realTimeEligibilityReport: true,
    insuranceInfoWritebacks: false,
    eligibilityPdfUploads: false,
    notes: null,
  },
  {
    practiceManagementSystem: 'MacPractice DDS',
    automaticVerification: false,
    manualVerification: true,
    realTimeEligibilityReport: true,
    insuranceInfoWritebacks: false,
    eligibilityPdfUploads: false,
    notes: null,
  },
  {
    practiceManagementSystem: 'Oasys',
    automaticVerification: false,
    manualVerification: true,
    realTimeEligibilityReport: true,
    insuranceInfoWritebacks: false,
    eligibilityPdfUploads: false,
    notes: null,
  },
  {
    practiceManagementSystem: 'OpenDental',
    automaticVerification: true,
    manualVerification: true,
    realTimeEligibilityReport: true,
    insuranceInfoWritebacks: true,
    eligibilityPdfUploads: true,
    notes: null,
  },
  {
    practiceManagementSystem: 'OrthoTrac Cloud',
    automaticVerification: false,
    manualVerification: true,
    realTimeEligibilityReport: true,
    insuranceInfoWritebacks: false,
    eligibilityPdfUploads: false,
    notes: null,
  },
  {
    practiceManagementSystem: 'OrthoTrac Server',
    automaticVerification: false,
    manualVerification: true,
    realTimeEligibilityReport: true,
    insuranceInfoWritebacks: false,
    eligibilityPdfUploads: false,
    notes: null,
  },
  {
    practiceManagementSystem: 'Patterson Fuse',
    automaticVerification: false,
    manualVerification: true,
    realTimeEligibilityReport: true,
    insuranceInfoWritebacks: false,
    eligibilityPdfUploads: false,
    notes: null,
  },
  {
    practiceManagementSystem: 'PracticeWeb',
    automaticVerification: false,
    manualVerification: true,
    realTimeEligibilityReport: true,
    insuranceInfoWritebacks: false,
    eligibilityPdfUploads: false,
    notes: null,
  },
  {
    practiceManagementSystem: 'PracticeWorks 7 (Server)',
    automaticVerification: false,
    manualVerification: true,
    realTimeEligibilityReport: true,
    insuranceInfoWritebacks: false,
    eligibilityPdfUploads: false,
    notes: null,
  },
  {
    practiceManagementSystem: 'Practiceworks Cloud',
    automaticVerification: false,
    manualVerification: true,
    realTimeEligibilityReport: true,
    insuranceInfoWritebacks: false,
    eligibilityPdfUploads: false,
    notes: null,
  },
  {
    practiceManagementSystem: 'Softdent 14',
    automaticVerification: false,
    manualVerification: true,
    realTimeEligibilityReport: true,
    insuranceInfoWritebacks: false,
    eligibilityPdfUploads: false,
    notes: null,
  },
  {
    practiceManagementSystem: 'Softdent 15',
    automaticVerification: false,
    manualVerification: true,
    realTimeEligibilityReport: true,
    insuranceInfoWritebacks: false,
    eligibilityPdfUploads: false,
    notes: null,
  },
  {
    practiceManagementSystem: 'Softdent 16/17/18/19 (Server)',
    automaticVerification: true,
    manualVerification: true,
    realTimeEligibilityReport: true,
    insuranceInfoWritebacks: false,
    eligibilityPdfUploads: false,
    notes:
      'Softdent version 16.2.8 and higher utilizes a cloud sync infrastructure which removes the capability for Automatic Verification.',
  },
  {
    practiceManagementSystem: 'Softdent Cloud',
    automaticVerification: false,
    manualVerification: true,
    realTimeEligibilityReport: true,
    insuranceInfoWritebacks: false,
    eligibilityPdfUploads: false,
    notes: null,
  },
  {
    practiceManagementSystem: 'WinOMS Cloud',
    automaticVerification: false,
    manualVerification: true,
    realTimeEligibilityReport: true,
    insuranceInfoWritebacks: false,
    eligibilityPdfUploads: false,
    notes: null,
  },
  {
    practiceManagementSystem: 'WinOMS Server',
    automaticVerification: false,
    manualVerification: true,
    realTimeEligibilityReport: true,
    insuranceInfoWritebacks: false,
    eligibilityPdfUploads: false,
    notes: null,
  },
];

/**
 * Labels for each PMS capability flag, used to render chips.
 */
export const PMS_CAPABILITY_LABELS: Record<
  keyof Omit<PmsCapability, 'practiceManagementSystem' | 'notes'>,
  string
> = {
  automaticVerification: 'Automatic Verification',
  manualVerification: 'Manual Verification',
  realTimeEligibilityReport: 'Real-Time Eligibility Report',
  insuranceInfoWritebacks: 'Insurance Info Writebacks',
  eligibilityPdfUploads: 'Eligibility PDF Uploads',
};

/**
 * Keys of the boolean capability flags on PmsCapability.
 */
export const PMS_CAPABILITY_KEYS = Object.keys(PMS_CAPABILITY_LABELS) as Array<
  keyof typeof PMS_CAPABILITY_LABELS
>;

/**
 * Strip all non-alphanumeric characters so that e.g. "dentrixg5" matches
 * "Dentrix G5" and "Eaglesoft 18/19/20/21" matches "eaglesoft18192021".
 */
const normalize = (str: string): string =>
  str
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]/g, '');

/**
 * Look up PMS capabilities by name. The sync-app `PracticeManagementSystem`
 * field often uses a slug-like format (e.g. "dentrixg5") while the static list
 * uses the display name (e.g. "Dentrix G5"). We normalize both sides by
 * stripping spaces, slashes, dashes and other non-alphanumeric characters
 * before comparing.
 */
export const findPmsCapabilities = (pmsName: string): PmsCapability | undefined => {
  const needle = normalize(pmsName);
  if (!needle) return undefined;

  // Exact normalized match first
  const exact = PMS_CAPABILITIES.find(
    (p) => normalize(p.practiceManagementSystem) === needle
  );
  if (exact) return exact;

  // Fallback: the normalized static name starts with the needle or vice-versa,
  // or one includes the other
  return PMS_CAPABILITIES.find((p) => {
    const hay = normalize(p.practiceManagementSystem);
    return (
      hay.startsWith(needle) ||
      needle.startsWith(hay) ||
      hay.includes(needle) ||
      needle.includes(hay)
    );
  });
};
